import GameServerPublicInfo from "../../models/GameServerPublicInfo";
import axios from "axios";
import BackendClient from "../../BackendClient";


export function getExpansionIcons(client: BackendClient): Promise<Array<string>> {
  return new Promise<Array<string>>((resolve, reject) => {
    axios.get(`${client.getBackendUrl()}${BackendClient.GetPublicExpansionIcons}`)
      .then((response) => resolve(response.data))
      .catch((reason) => {
        console.log(`Exception when fetching expansion icons info: ${JSON.stringify(reason)}`);
        reject(reason);
      });
  });
}